<template>
  <div>
    <navbar title="库存详情" />
    <!-- 商品详情 -->
    <van-collapse class="detail-content" v-model="activeNames">
      <van-collapse-item
        :title="details.product_name"
        :value="sufficient(details.remaining_inventory)"
        name="1"
        value-class="right-text"
      >
        <div class="body">
          <van-cell title="产品规格" :value="details.product_specification" />
          <van-cell title="最新单价(含税)" :value="details.qd_price" />
          <van-cell title="剩余库存" :value="details.remaining_inventory" />
          <!-- <van-cell
            title="累计库存"
            :value="
              details.total_quantity -
              details.ph_quantity -
              details.not_ph_quantity
            "
          /> -->
          <van-cell title="预出库数量" :value="details.advance" />
          <van-cell title="可用数量" :value="details.available" />
          <!-- <van-cell title="剩余数量" :value="details.residue" /> -->
          <!-- <van-cell title="批次号" :value="details.inbound_ph" />
          <van-cell title="入库数量" :value="details.quantity" /> -->
        </div>
      </van-collapse-item>
    </van-collapse>
    <!-- 商品详情表格数据 -->
    <van-list
      v-model="list.loading"
      :finished="list.finished"
      finished-text="没有更多了"
      @load="onLoad"
      offset="50"
    >
      <ul class="tab-ul van-clearfix">
        <li class="tab-title van-clearfix">
          <van-sticky>
            <!-- <van-button type="primary">基础用法</van-button> -->
            <span>批次号</span>
            <span>入库数量</span>
            <span>剩余数量</span>
          </van-sticky>
        </li>
        <li
          class="tab-content van-clearfix"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <span>{{ item.inbound_ph || 0 }}</span>
          <span>{{ item.quantity || 0 }}</span>
          <span>{{ item.residue || 0 }}</span>
        </li>
      </ul>
    </van-list>
  </div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { get } from "@/api/stock";
import { Toast } from "vant";

export default {
  components: {
    navbar,
  },
  data() {
    return {
      activeNames: ["1"], //折叠面板0默认折叠，1默认打开
      list: {
        requestType: "getInboundPh",
        loading: false, //表格数据加载loading
        finished: false, //表格加载完毕
        page: 1,
        limit: 30,
        product_id: "",
      },
      dataList: [],
      details: {},
    };
  },
  methods: {
    onLoad() {
      if (this.list.page == 1) this.details = this.$route.params;
      console.log(this.details);
      this.list.product_id = this.details.product_id;
      this.list.loading = true;
      get(this.list)
        .then((response) => {
          if (this.list.page != 1) {
            this.dataList = this.dataList.concat(response.obj.rows);
          } else {
            this.dataList = response.obj.rows;
          }
          if (this.dataList.length == response.obj.total) {
            this.list.finished = true;
          }
          this.list.page += 1;
          this.list.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.list.loading = false;
          this.list.finished = true;
          return Toast("数据异常");
        });
    },
    sufficient(num) {
      if (num > 0) {
        return "库存充足";
      } else {
        return "库存不足";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.right-text {
  color: red !important;
}
/deep/.van-collapse-item__content {
  padding: 0;
}
.van-tag + .van-tag {
  margin-left: 8px;
}
.popup-details {
  width: 100%;
  height: 100%;
}
.tab-ul {
  padding: 20px 0;
  background-color: #fffbe8;
  li {
    line-height: 30px;
    span {
      width: 30%;
      display: block;
      float: left;
      text-align: center;
      &:first-child {
        width: 40% !important;
      }
    }
  }
  .tab-title {
    span {
      font-weight: bold;
      font-size: 13px;
      background-color: #fffbe8;
    }
  }
}
</style>
